/**
 * Ably 频道工具类
 * 提供频道名称生成功能
 */
export class AblyChannelUtils {
  /// 获取群组聊天频道ID
  static getGroupChannelId(groupId: string): string {
    return `chat:group:${groupId}`;
  }

  /// 获取当前用户邮箱频道ID（接收消息）
  static getCurrentUserChannelId(userHandle: string): string {
    return `chat:mailbox:${userHandle}`;
  }

  // 获取消息确认频道ID
  static getAckChannelId(): string {
    return 'chat:ack';
  }

  // 获取用户发送消息的目标频道ID
  static getTargetUserChannelId(targetUserHandle: string): string {
    return `chat:mailbox:${targetUserHandle}`;
  }

  /**
   * 根据会话类型获取发送频道ID
   * @param conversationId 会话ID
   * @param sessionType 会话类型 ('direct' | 'group')
   * @param targetUserHandle 目标用户句柄（私聊时必需）
   * @returns 发送频道名称
   */
  static getSendChannelId(
    conversationId: string,
    sessionType: 'direct' | 'group',
    targetUserHandle?: string
  ): string {
    if (sessionType === 'group') {
      return this.getGroupChannelId(conversationId);
    } else {
      if (!targetUserHandle) {
        throw new Error('私聊消息需要提供目标用户句柄');
      }
      return this.getTargetUserChannelId(targetUserHandle);
    }
  }
}

export default AblyChannelUtils;
